import { APP_THEME_LIGHT } from '../../const';

export default ((): AppState => ({
  theme: APP_THEME_LIGHT,
}))();
